import React from 'react';
import { TopoLines } from './TopoLines';
type Tome = {
  number: string;
  title: string;
  meetings: string;
  promise: string;
  band: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'Launch the Year',
  meetings: 'M01–M10',
  promise: 'Team, patrols and a meeting rhythm that runs itself.',
  band: 'bg-forest',
  contents: ['Name-Game, Group Agreement and Patrol Nights to start strong', 'Pack-your-bag, layering and trail-manners nights', 'The Age Dial, the Patrol Huddle Loop and the Rain Swap Rule', 'From adult-led to patrol-led in four steps', 'Capture the Flag done safely, plus a real Service Night']
}, {
  number: '02',
  title: 'Knots, Ropes & Pioneering',
  meetings: 'M11–M20',
  promise: 'From the first square knot to a patrol-built structure.',
  band: 'bg-bark',
  contents: ['The six knots that cover nearly every camp job', 'The Show-Mirror-Test method for teaching any knot', 'Square, diagonal and shear lashings, step by step', 'A-frames, tripods and a tabletop bridge — with the Load Check', 'Knot Passport and relay scoresheets ready to print']
}, {
  number: '03',
  title: 'Fire, Camp Cooking & Camp Tools',
  meetings: 'M21–M30',
  promise: 'Supervised skills for blades, saws, fire and patrol meals.',
  band: 'bg-ember-deep',
  contents: ['The Safe-Tool Zone for knives and saws', 'The Fire Permission Ladder: build, light, tend, put out cold', 'Fire lays, ferro-rod sparks and a dead-out cold check', 'Patrol menus on a budget, stove one-pots and foil packs', 'Indoor, no-flame versions for every fire and tool lesson']
}, {
  number: '04',
  title: 'Navigation, Hiking & Weather',
  meetings: 'M31–M40',
  promise: 'Maps, compasses and trails kids can follow.',
  band: 'bg-sky',
  contents: ['Map-First Navigation: read the land before the needle', 'Grid references, contours and the Three-Step Bearing', 'Pacing and a score-orienteering course around your site', 'The Hike Readiness Gate and the Regroup Rule', 'Read the sky: clouds and what they warn you about']
}, {
  number: '05',
  title: 'First Aid, Safety & Survival',
  meetings: 'M41–M50',
  promise: 'Calm hands when something goes wrong outdoors.',
  band: 'bg-signal',
  contents: ['Look, Call, Help: the three-step response kids remember', 'Cuts, sprains, heat and cold, and calling for help clearly', 'The Patrol Survival Order: shelter, signal, water, food', 'Tarp and debris shelters, whistles and signal mirrors', 'An introduction for young first aiders — not a certification']
}, {
  number: '06',
  title: 'Nature, Night Sky & Big Adventure Nights',
  meetings: 'M51–M60',
  promise: 'Wildlife, stars and skill nights kids talk about for weeks.',
  band: 'bg-moss-deep',
  contents: ['Trees, tracks and bug safaris that feel like detective work', 'Birds, moon phases and a star finder they build themselves', 'Night senses walks with the Big Night Safety Plan', 'Skills Night stations and a patrol overnight plan', 'Showcase Night: the kids show families what they can do']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="topo-light w-full bg-paper" data-id="element-287" data-mp="dvzegp1gkxw7">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-288" data-mp="du634wfwhphv">
        <div className="text-center" data-id="element-289" data-mp="ivvi2n68unb8">
          <p className="eyebrow text-ember-deep" data-id="element-290" data-mp="ispp2wuhv1a8">The Troop Night Trail</p>
          <h2 id="tomes-heading" className="trail-underline mt-3 font-display text-[30px] leading-tight text-pine sm:text-5xl" data-id="element-291" data-mp="mve1feif2qby">
            Inside the pack — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-pine-soft" data-id="element-292" data-mp="3r92qn19rvh9j">
            Ten meetings per volume, one skill area each. Use them in order for
            a full year, or jump to whatever your group needs this week.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-293" data-mp="379u66k4amd1g">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col overflow-hidden rounded-2xl border border-paper-dark bg-white shadow-card" data-id="element-294" data-mp="3lygsx6w9272p">
              <div className={`relative overflow-hidden ${tome.band}`} data-id="element-295" data-mp="3uxbzik37hj6j">
                <TopoLines className="pointer-events-none absolute -right-6 -top-8 h-28 w-28 text-white/20" data-id="element-296" data-mp="3pzitbr1wkp69" />
                <div className="relative flex items-center justify-between px-5 py-3.5" data-id="element-297" data-mp="8ros7hdt7dd4">
                  <span className="text-[11px] font-bold uppercase tracking-[2px] text-white/90" data-id="element-298" data-mp="3sbyccoit611">
                    Volume {tome.number} · {tome.meetings}
                  </span>
                  <span className="font-display text-3xl leading-none text-white" data-id="element-299" data-mp="2akcy5yhu8ewl">
                    {tome.number}
                  </span>
                </div>
              </div>

              <div className="trail-card flex flex-1 flex-col p-6 pt-5" data-id="element-300" data-mp="l3hgqc0nif93">
                <h3 className="font-display text-xl leading-snug text-pine" data-id="element-301" data-mp="pz6atztwj3y0">
                  {tome.title}
                </h3>
                <p className="mt-1.5 text-sm text-pine-soft" data-id="element-302" data-mp="b9h13g7qtrm4">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-paper-dark pt-4" data-id="element-303" data-mp="g93ebpnkn7ux">
                  {tome.contents.map(item => <li key={item} className="flex gap-2.5 text-[14px] leading-snug text-pine" data-id="element-304" data-mp="6ciav8r7a4t7">
                      <span className="mt-[6px] h-2 w-2 flex-none rounded-full bg-ember" data-id="element-305" data-mp="3oi3ddtfkf134" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}